/*
 * @Author: zjt
 * @Email: 13928932429@163.com
 * @Date: 2020-08-05 15:48:09
 * @LastEditTime: 2020-10-27 09:29:26
 * @Description: 销售项目store
 */
import {
  getPayment,
  getPaymentById,
  updatePayment,
  createPayment,
  deletePayment
} from '@/api/payment'
import Vue from 'vue'

const state = {
  paymentList: [],
  totalCounts: 0
}

const getters = {}

const actions = {
  async getPaymentAction({
    commit
  }, payload) {
    try {
      const res = await getPayment(payload)
      commit('SET_PAYMENT', res.data)
      return res.data
    } catch (error) {
      throw error.message
    }
  },
  async createPaymentAction({
    commit
  }, payload) {
    try {
      const newPayment = await createPayment(payload);
      commit('ADD_PAYMENT', newPayment.data)
    } catch (error) {
      throw error.message
    }
  },
  async updatePaymentAction({
    commit
  }, payload) {
    try {
      const newPayment = await updatePayment(payload.id, payload.data)
      commit("UPDATE_PAYMENT", newPayment.data.payment)
      return newPayment.data
    } catch (error) {
      throw error.message
    }
  },
  async deletePaymentAction({
    commit
  }, payload) {
    try {
      await deletePayment(payload)
      commit('DELETE_PAYMENT', payload)
    } catch (error) {
      throw error.message
    }
  }
}

const mutations = {
  SET_PAYMENT(state, payload) {
    state.paymentList = payload.paymentList
    state.totalCounts = payload.totalCounts
  },
  UPDATE_PAYMENT(state, payment) {
    Vue.set(state.paymentList, state.paymentList.findIndex(x => x._id === payment._id), payment)
  },
  ADD_PAYMENT(state, payment) {
    state.paymentList.unshift(payment)
    state.totalCounts++
  },
  // UPDATESALES(state, sales) {
  //     Vue.set(state.sales, state.sales.findIndex(x => x._id === sales._id), sales)
  // },
  DELETE_PAYMENT(state, id) {
    state.paymentList = state.paymentList.filter(e => e._id !== id)
    state.totalCounts--
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}